import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
import { nextVersionClicks } from '../utils/easterEggs';

interface EasterEggContextValue {
  devMode: boolean;
  logoSpin: number;
  triggerKonami: () => void;
  registerVersionClick: () => boolean;
}

const EasterEggContext = createContext<EasterEggContextValue>({
  devMode: false,
  logoSpin: 0,
  triggerKonami: () => {},
  registerVersionClick: () => false,
});

export const useEasterEgg = () => useContext(EasterEggContext);

export const EasterEggProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [devMode, setDevMode] = useState(false);
  const [logoSpin, setLogoSpin] = useState(0);
  const clicks = useRef(0);

  const triggerKonami = useCallback(() => {
    setLogoSpin((prev) => prev + 1);
  }, []);

  const registerVersionClick = useCallback(() => {
    const step = nextVersionClicks(clicks.current);
    clicks.current = step.clicks;
    if (step.unlocked) {
      setDevMode(true);
      return true;
    }
    return false;
  }, []);

  const value = useMemo(
    () => ({ devMode, logoSpin, triggerKonami, registerVersionClick }),
    [devMode, logoSpin, triggerKonami, registerVersionClick],
  );

  return <EasterEggContext.Provider value={value}>{children}</EasterEggContext.Provider>;
};
